import { Box, Paper, Typography } from '@mui/material'
import InfoTooltip from 'components/InfoTooltip'

interface Props {
  title: string
  tooltip?: string
  children: React.ReactNode
}

const ChartPanel = ({ title, tooltip, children }: Props) => (
  <Paper variant='outlined' sx={{ borderRadius: 2, overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ bgcolor: '#002C5F', px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Typography variant='caption' sx={{ color: '#fff', fontWeight: 700, letterSpacing: 0.5 }}>
        {title.toUpperCase()}
      </Typography>
      {tooltip && <InfoTooltip title={tooltip} variant='light' iconColor='rgba(255,255,255,0.8)' />}
    </Box>
    <Box sx={{ p: 2, flex: 1 }}>{children}</Box>
  </Paper>
)

export default ChartPanel
